module.exports = __webpack_public_path__ + "img/service3.c507c9b.svg";